/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminPalletOrderAttachmentMetadata,
    AdminPalletOrderAttachmentMetadataFromJSON,
    AdminPalletOrderAttachmentMetadataFromJSONTyped,
    AdminPalletOrderAttachmentMetadataToJSON,
} from './AdminPalletOrderAttachmentMetadata';

/**
 * 
 * @export
 * @interface AdminPalletOrderAttachments
 */
export interface AdminPalletOrderAttachments {
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderAttachments
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderAttachments
     */
    id: number;
    /**
     * 
     * @type {AdminPalletOrderAttachmentMetadata}
     * @memberof AdminPalletOrderAttachments
     */
    meta: AdminPalletOrderAttachmentMetadata;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderAttachments
     */
    name: string;
}

export function AdminPalletOrderAttachmentsFromJSON(json: any): AdminPalletOrderAttachments {
    return AdminPalletOrderAttachmentsFromJSONTyped(json, false);
}

export function AdminPalletOrderAttachmentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrderAttachments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'meta': AdminPalletOrderAttachmentMetadataFromJSON(json['meta']),
        'name': json['name'],
    };
}

export function AdminPalletOrderAttachmentsToJSON(value?: AdminPalletOrderAttachments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'meta': AdminPalletOrderAttachmentMetadataToJSON(value.meta),
        'name': value.name,
    };
}

